import Header from "./Header";
import "./supportPortal/supportPortal.css";
import AuthView from "./supportPortal/AuthView";
import SupportPortalConnectedView from "./supportPortal/SupportPortalConnectedView";
import SupportPortalDialogs from "./supportPortal/SupportPortalDialogs";
import { useSupportPortal } from "./supportPortal/useSupportPortal";

export default function SupportPortal() {
  const portal = useSupportPortal();
  const {
    auth: {
      forgotPasswordForm,
      handleForgotPassword,
      handleLogin,
      handleResetPassword,
      isResetPasswordFormValid,
      loginForm,
      mode,
      resetPasswordForm,
      setForgotPasswordForm,
      setLoginForm,
      setMode,
      setResetPasswordForm,
      setShowLoginPassword,
      setShowResetPassword,
      setShowResetPasswordConfirm,
      showLoginPassword,
      showResetPassword,
      showResetPasswordConfirm,
    },
    session: {
      user,
    },
    ui: {
      loading,
    },
  } = portal;
  return (
    <div className="min-h-screen" style={{ background: "var(--bg-page)" }}>
      <Header />
      {!user ? (
        <AuthView
          mode={mode}
          setMode={setMode}
          loading={loading}
          loginForm={loginForm}
          setLoginForm={setLoginForm}
          forgotPasswordForm={forgotPasswordForm}
          setForgotPasswordForm={setForgotPasswordForm}
          resetPasswordForm={resetPasswordForm}
          setResetPasswordForm={setResetPasswordForm}
          showLoginPassword={showLoginPassword}
          setShowLoginPassword={setShowLoginPassword}
          showResetPassword={showResetPassword}
          setShowResetPassword={setShowResetPassword}
          showResetPasswordConfirm={showResetPasswordConfirm}
          setShowResetPasswordConfirm={setShowResetPasswordConfirm}
          isResetPasswordFormValid={isResetPasswordFormValid}
          handleLogin={handleLogin}
          handleForgotPassword={handleForgotPassword}
          handleResetPassword={handleResetPassword}
        />
      ) : (
        <SupportPortalConnectedView portal={portal} />
      )}
      <SupportPortalDialogs portal={portal} />
    </div>
  );
}
